/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useEffect } from 'react';
import { View } from 'react-native';
import { Router, navigate } from '@reach/router';

import ScreenHome from '../components/screenHome';
import ScreenMyPage from '../components/screenMyPage';
import ScreenModal from '../components/screenModal';

import Menu from '../components/menu';
import { themeStyles } from '../config';

import Home from '../project/screens/Home';
import SelectProfile from '../project/screens/SelectProfile';
import ConfirmExit from '../project/screens/ConfirmExit';
import AccessCode from '../project/screens/AccessCode';
import Catalog from '../project/screens/Catalog';
import VideoPlayer from '../project/components/VideoPlayer';
import Limit from '../project/screens/Limit';
import Settings from '../project/screens/Settings';
import ModalCore from '../project/components/Modal';
import useOnline from '../project/hooks/useOnline';
import { getScaledValue } from '../project/ui/styled';

const App = () => {
  useOnline();

  useEffect(() => {
    // Required for tizen
    if (window.focus) window.focus();

    try {
      // FIXME(phase-18-ui-hoxxtv): replace manual DOM IntersectionObserver with React-based lazy loading hook
      const lazyImages = document.querySelectorAll('.lazy');

      const observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const img = entry.target as HTMLImageElement;
            img.src = (img.dataset as Record<string, string>).src ?? '';
            img.classList.remove('lazy');
            obs.unobserve(img);
          }
        });
      });

      lazyImages.forEach(function (img) {
        observer.observe(img);
      });
    } catch (e) {}

    try {
      // Disable TTS on TV platforms without removing the full speechSynthesis API
      if (window.speechSynthesis) {
        window.speechSynthesis.speak = function () {
          console.log('TTS is disabled');
        };
      }
    } catch (e) {}
  }, []);

  return (
    <View style={themeStyles.app}>
      {/* <Menu focusKey="menu" navigate={navigate} /> */}
      <View style={themeStyles.appContainer}>
        <Router>
          <Home path="/" />
          <Limit path="/limit" />
          <ConfirmExit path="/confirm-exit" />
          <SelectProfile path="/select-profile" />
          <VideoPlayer path="/video" />
          <Catalog path="/catalog" />
          <Catalog path="/favorites" />
          <Catalog path="/search" />
          <AccessCode path="/access-code" />
          <Settings path="/settings" />

          {/* <ScreenMyPage path="my-page" /> */}
          {/* <ScreenModal path="modal" /> */}
        </Router>
      </View>
      <ModalCore />

      {/* <div style={{ position:'absolute', background:'white', top: 0, right: 0, height: `${ getScaledValue(10) }px`, width: `${ getScaledValue(40) }px` }}>
                { pressed?.join('\n') }
            </div> */}
    </View>
  );
};

export default App;
